import axios from 'axios';

const baseApiUrl = 'api/organization-preview';

export default class OrganizationPreviewService {
  public getAdvertisements(type?: number, organizationId?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}/advertisements?sort=id,desc`;
      if (type) {
        url += `&type=${type}`;
      }
      if (organizationId) {
        url += `&organizationId=${organizationId}`;
      }
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getInfrastructures(type?: number, organizationId?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}/infrastructures?sort=id,desc`;
      if (type) {
        url += `&type=${type}`;
      }
      if (organizationId) {
        url += `&organizationId=${organizationId}`;
      }
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getServices(type?: number, organizationId?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}/services?sort=id,desc`;
      if (type) {
        url += `&type=${type}`;
      }
      if (organizationId) {
        url += `&organizationId=${organizationId}`;
      }
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateInfrastructureActivationStatus(infrastructureId: number, statusId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`api/research-infrastructures/update-activation-status/${infrastructureId}/${statusId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateServiceActivationStatus(serviceId: number, statusId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`api/ri-services/update-activation-status/${serviceId}/${statusId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
